import { gql } from '@apollo/client';

export default class TagQuery {
    static GET_TAG_BY_CRM_MODULE = gql`
        query getTagByCRMModule($paginate: DataPaging, $active: Boolean) {
            getTagByCRMModule(paginate: $paginate, active: $active) {
                totalCount
                data {
                    tagId
                    name
                    color
                    description
                    module
                    priority
                }
            }
        }
    `;

    static GET_TAGS_BY_MODULE = gql`
        query getTagsByModule($module: String!, $sort: DataSort) {
            getTagsByModule(module: $module, sort: $sort) {
                tagId
                name
                description
                module
                priority
                color
                active
                createdBy
                createdOn
                modifiedBy
                modifiedOn
            }
        }
    `;

    static GET_TAGS_BY_STOCK_NUMBER = gql`
        query getTagsByStockNumber($stockNumber: Int!, $sort: DataSort) {
            getTagsByStockNumber(stockNumber: $stockNumber, sort: $sort) {
                tagId
                name
                description
                module
                priority
                color
                active
                createdBy
                createdOn
                modifiedBy
                modifiedOn
            }
        }
    `;
}
